import React, { useEffect } from "react";
import {
  GiftIcon,
  SparklesIcon,
  CalendarDaysIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  CreditCardIcon,
  HeartIcon,
  InformationCircleIcon,
  NewspaperIcon,
  PhotoIcon,
  QuestionMarkCircleIcon,
  ShieldCheckIcon,
} from "@heroicons/react/24/outline";

import { useNotify } from "../../../hooks/useNotify";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";

const routes = [
  {
    title: "exchanges",
    pages: [
      {
        title: "Official exchanges",
        href: "/exchanges/official",
        icon: <GiftIcon className="w-5 h-5" />,
        description:
          "This is where you'll find our monthly official exchanges.",
        auth: false,
      },
      {
        title: "User exchanges",
        href: "/exchanges/user",
        icon: <GiftIcon className="w-5 h-5" />,
        description:
          "Come look at the exchanges our fabulous users have created.",
        auth: false,
      },
      {
        title: "Exchange calendar",
        href: "/exchanges/upcoming",
        icon: <CalendarDaysIcon className="w-5 h-5" />,
        description: "View our upcoming exchanges.",
        auth: false,
      },
      {
        title: "Rematchers needed",
        href: "/exchanges/required",
        icon: <SparklesIcon className="w-5 h-5" />,
        description: "See which giftee's are in need of a gift.",
        auth: false,
      },
    ],
    auth: false,
  },
  {
    title: "gallery",
    pages: [
      {
        title: "Gallery",
        href: "/gallery",
        icon: <PhotoIcon className="w-5 h-5" />,
        description: "Come and see what everybody has sent and received!",
        auth: false,
      },
      {
        title: "Hall of fame",
        href: "/gallery/hall-of-fame",
        icon: <HeartIcon className="w-5 h-5" />,
        description: "View the most liked and awarded posts.",
        auth: false,
      },
    ],
    auth: false,
  },
  {
    title: "discover",
    pages: [
      {
        title: "How it works",
        href: "/discover/how-it-works",
        icon: <QuestionMarkCircleIcon className="w-5 h-5" />,
        description: "This where you'll find out how it all works.",
        auth: false,
      },
      {
        title: "Who we are",
        href: "/discover/who-we-are",
        icon: <InformationCircleIcon className="w-5 h-5" />,
        description: "Learn more about Givin Gifts and the team behind it.",
        auth: false,
      },

      {
        title: "Blog",
        href: "/blog",
        icon: <NewspaperIcon className="w-5 h-5" />,
        description: "Read our blog for the latest news and updates.",
        auth: false,
      },
      {
        title: "Contact and support",
        href: "/discover/contact-us",
        icon: <ChatBubbleOvalLeftEllipsisIcon className="w-5 h-5" />,
        description: "Contact us for help and support.",
        auth: false,
      },
      {
        title: "Support us",
        href: "/discover/support-us",
        icon: <CreditCardIcon className="w-5 h-5" />,
        description: "Find out how you can support the cause",
        auth: false,
      },
    ],
    auth: false,
  },
  {
    title: "premium",
    pages: [
      {
        title: "Premium membership",
        href: "/premium",
        icon: <ShieldCheckIcon className="w-5 h-5" />,
        description:
          "Upgrade to our premium membership to unlock exclusive features.",
        auth: false,
      },
      {
        title: "My premium",
        href: "/account/premium",
        icon: <ShieldCheckIcon className="w-5 h-5" />,
        description: "Access your premium membership.",
        auth: true,
        premium: true,
      },
    ],
    auth: false,
  },
  {
    title: "admin",
    pages: [
      {
        title: "Create Exchange",
        href: "/exchange/create",
        auth: true,
        admin: true,
      },
      {
        title: "Create Blog Post",
        href: "/admin/blog",
        auth: true,
        admin: true,
      },
      {
        title: "Manage DNM",
        href: "/admin/dnm",
        auth: true,
        admin: true,
      },
      {
        title: "Manage FAQ",
        href: "/admin/faq",
        auth: true,
        admin: true,
      },
      {
        title: "Manage Proof",
        href: "/admin/proof",
        auth: true,
        admin: true,
      },
      {
        title: "Manage Users",
        href: "/admin/users",
        auth: true,
        admin: true,
      },
      {
        title: "View Duplicates",
        href: "/admin/duplicates",
        auth: true,
        admin: true,
      },
      {
        title: "View Suspicious",
        href: "/admin/suspicious",
        auth: true,
        admin: true,
      },
    ],
    auth: true,
    admin: true,
  },
];

function Header() {
  return (
    <>
      <HeaderDesktop routes={routes} />
      <HeaderMobile routes={routes} />
    </>
  );
}

export default Header;
